import * as React from "react";

import "./scheduled-campaigns-route.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {buildUrlQuery}  from "@Common/utils/build-url-query";

import {AGENT_LEVEL, BRANCH_LEVEL} from "../../../common/logic/user-level";
import {SelectUserPanel}           from "../../../common/select-user-panel/select-user-panel";
import {AccountLayout}             from "../../common/account-layout/account-layout";
import {ScheduledCampaignsPanel}   from "../../common/scheduled-campaigns-panel/scheduled-campaigns-panel";

export const ScheduledCampaignsRoute = ({match}) => cs(
    consumeContext("session"),
    ["panel", ({session}, next) => ScheduledCampaignsPanel({
        // agentId: session.value.agentId,
        branchId: session.value.branchId,
        next,
    })],
    ["panel", ({panel}, next) => panel.render({
        initStep: match.params.step,
        next,
    })],

    ({panel}, next) => AccountLayout({
        active: "scheduledCampaigns",
        activeTab: "drip-campaign",
        navBlock: panel.navBlock,
        next,
    }),


    consumeContext("userLevels"),
    ({session, userLevels}, next) => session.loading || !userLevels ? "Loading session..." : next(),
    ({session, userLevels}, next) => userLevels.userLevel !== AGENT_LEVEL ? (
        RedirectingToUserAssets()
    ) : (
        next()
    ),
    ({}, next) => (
        <div className="scheduled-campaigns-route-45m">
            {next()}
        </div>
    ),

    ({panel}) => panel.render(),
);

/**
 * This show a box for selecting agentId+branchId so the admin will be redirected to user assets page of that agent
 */
const RedirectingToUserAssets = () => cs(
    consumeContext("session"),
    consumeContext("userLevels"),
    ({}, next) => (
        <div className="redirecting-to-user-assets-4f2">
            <div className="box">
                {next()}
            </div>
        </div>
    ),
    ["panel", ({userLevels, session}, next) => SelectUserPanel({
        ...userLevels.userLevel === BRANCH_LEVEL && {
            forcedBranchId: session.value.branchId,
            multiBranch: false,
        },
        next,
    })],
    consumeContext("routerHistory"),
    ({panel, routerHistory, userLevels}) => <>
        <div {...{
            className: "message",

            "xd-qa-type": "text",
            "xd-qa-name": "Redirecting to User Assets message",
        }}>
            {userLevels.userLevel === BRANCH_LEVEL ? (
                "Please select the User whose preferences you want to view"
            ) : (
                "Please select the Office and User whose preferences you want to view"
            )}
        </div>

        <div className="content">
            {panel.render()}
        </div>
        {/*{console.log("panel.value", panel.value)}*/}
        <div className="footer">
            <button {...{
                className: "next",
                disabled: !panel.value?.agentId,
                onClick: () => {
                    // console.log("panel.value", panel.value);
                    // /account/admin/scheduled-campaigns
                    routerHistory.push("/account/admin/user/scheduled-campaigns" + buildUrlQuery({
                        agent: panel.value.agentId,
                        branch: panel.value.branchId,
                    }));
                },

                "xd-qa-type": "button",
                "xd-qa-name": "Next",
            }}>
                Next
            </button>
        </div>
    </>,
);

